class Burger
{
    constructor(elem)
    {
        // DOM.
        this.$elem    = jQuery(elem);
        this.$closer  = jQuery('[data-role="menu-closer"]');
        this.$menu    = jQuery('.menu');
        this.$bg      = jQuery('.menu__bg');
        this.isOpened = false;
        
        // Events.
        this.$elem.on('click', () => this.open());
        this.$closer.on('click', () => this.close());
    }

    onBurgerClick()
    {
        this.isOpened ? this.close() : this.open();
        this.isOpened = !this.isOpened;
    }

    open()
    {
        this.$elem.fadeOut();
        this.$bg.show();
        this.$menu.addClass('open');
    }
    
    close()
    {
        this.$elem.fadeIn();
        this.$bg.hide();
        this.$menu.removeClass('open');
    }
}


jQuery(function()
{
    // Creates one instance per component,
    // allows to have the same component multiple times on same page.
    // Preference: target a data attribute for distinction between style and functionality.
    jQuery('[data-component="burger"]').each(function() {
        new Burger(this);
    });
});